import React, { useEffect, useState } from "react";
import api from "@/lib/api";

// Fetches an authenticated file (blob) and renders it as an <img>.
export default function AuthImage({ fileId, alt = "", className = "", fallback = null, ...rest }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!fileId) { setUrl(null); return; }
    let objectUrl;
    let active = true;
    setFailed(false);
    api.get(`/files/${fileId}/download`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      })
      .catch(() => active && setFailed(true));
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [fileId]);

  if (!fileId || failed || !url) return fallback;
  return <img src={url} alt={alt} className={className} {...rest} />;
}
